import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year3/Spring/MassAndCapacity/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'MassAndCapacity',
  field: 'Measurement',
  weeks: [10, 12],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(/* webpackChunkName: "Year3/Spring/MassAndCapacity/1UseScales" */ './1UseScales')
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/2MeasureMassInGrams" */ './2MeasureMassInGrams'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/3MeasureMassInKilogramsAndGrams" */ './3MeasureMassInKilogramsAndGrams'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/4EquivalentMassesKilogramsAndGrams" */ './4EquivalentMassesKilogramsAndGrams'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(/* webpackChunkName: "Year3/Spring/MassAndCapacity/5CompareMass" */ './5CompareMass')
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/6AddAndSubtractMass" */ './6AddAndSubtractMass'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/7MeasureCapacityAndVolumeInMillilitres" */ './7MeasureCapacityAndVolumeInMillilitres'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/8MeasureCapacityAndVolumeInLitresAndMillilitres" */ './8MeasureCapacityAndVolumeInLitresAndMillilitres'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/9EquivalentCapacitiesAndVolumesLitresAndMillilitres" */ './9EquivalentCapacitiesAndVolumesLitresAndMillilitres'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/10CompareCapacityAndVolume" */ './10CompareCapacityAndVolume'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/MassAndCapacity/11AddAndSubtractCapacityAndVolume" */ './11AddAndSubtractCapacityAndVolume'
        )
    })
  ]
});
export default Block;
